@if (alert) {
	<ea-ui-sticky [zIndex]="9000">
		<ea-alert [alert]="alert"></ea-alert>
	</ea-ui-sticky>
}
